import type { TextFieldProps as ITextFieldProps } from '@mui/material';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  TextField,
} from '@mui/material';
import type { FC, ReactNode } from 'react';
import { forwardRef } from 'react';

// const BootstrapInput: any = styled(TextField)(({ theme }) => ({}));

/**
 * for hide / show password type input : use "PasswordField" component
 */

export type ICustomTextFieldProps = ITextFieldProps & {
  capitalize?: boolean;
  label?: any;
  variant?: 'standard' | 'outlined' | 'filled' | undefined;
  placeholder?: string;
  required?: boolean;
  autoComplete?: string;
  maxWidth?: string;
  helperText?: any;
  endAdornment?: ReactNode;
  multiline?: boolean;
  minRows?: any;
  ref?: any;
  onChange?: (event: any) => void;
  custom?: string;
};

const LabelledTextField: FC<ICustomTextFieldProps> = forwardRef(
  (props, ref) => {
    const {
      variant,
      type,
      error,
      helperText,
      className,
      maxWidth,
      size,
      disabled,
      capitalize,
      multiline,
      minRows,
      InputProps = {},
      required,
      label,
      custom,
      ...restOfTextFieldProps
    } = props;

    return (
      <FormControl
        variant={variant}
        className={`${className} ${maxWidth || 'w-full'}`}
        color="primary"
      >
        <InputLabel
          shrink
          disabled={disabled}
          required={required}
          variant="standard"
          className="font-medium"
        >
          {label}
        </InputLabel>
        <TextField
          fullWidth
          type={type}
          id="bootstrap-input"
          margin="dense"
          className={`!rounded-lg  ${capitalize ? 'capitalize' : ''} `}
          {...restOfTextFieldProps}
          inputRef={ref}
          InputProps={InputProps}
          size={size}
          multiline={multiline}
          minRows={minRows}
          disabled={disabled}
          color="primary"
          error={Boolean(error)}
          sx={
            label && {
              marginTop: '26px',
              '& .MuiInputBase-root': {
                padding: '0px',
              },
            }
          }
        />
        {Boolean(error) && (
          <FormHelperText
            error={Boolean(error)}
            variant={variant}
            className="ml-0 max-w-lg"
          >
            {helperText || ' '}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
);

LabelledTextField.displayName = 'LabelledTextField';

LabelledTextField.defaultProps = {
  variant: 'standard',
  type: 'text',
  error: false,
  helperText: '',
  className: '',
  inputRef: null,
  size: 'medium',
  disabled: false,
  required: false,
};

export default LabelledTextField;
